const mapOptions = (options) => {
    if (!options)
        return null;
    if (Array.isArray(options)) {
        return options.map(option => ({ value: String(option), label: String(option) }));
    }
    return Object.entries(options).map(([value, label]) => ({ value, label: String(label) }));
};
export const normalizeCampaignSchema = (response) => {
    if (!response?.data)
        return [];
    return Object.entries(response.data).map(([categoryKey, fields]) => {
        const descriptors = Object.entries(fields).map(([fieldKey, field]) => ({
            id: fieldKey,
            categoryId: categoryKey,
            label: field.name,
            type: field.type,
            format: field.format,
            multiple: Boolean(field.multiple),
            operators: field.operators ?? [],
            options: mapOptions(field.options),
            autocomplete: Boolean(field.autocomplete),
            enabled: field.enabled,
            raw: field,
        }));
        return {
            id: categoryKey,
            label: categoryKey,
            fields: descriptors,
        };
    });
};
